// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1Z8N6","consentsList":"PatientConsents_consentsList__1GvrM","consentsListEmpty":"PatientConsents_consentsListEmpty__1znvI"};